module.exports = __webpack_public_path__ + "static/img/backs.77d9957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backs.png
// module id = PiN0
// module chunks = 1